export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left - Text */}
          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
              About The Resource
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5 leading-tight">
              What Is <span className="text-primary-500">Hipobuy Spreadsheet</span>?
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>
                A <strong>Hipobuy Spreadsheet</strong> is an organized digital resource that compiles product listings, category breakdowns, and detailed item comparisons into a structured, easy-to-navigate format. Unlike traditional online stores where products are scattered across countless pages, a spreadsheet-based approach consolidates everything into one accessible reference point.
              </p>
              <p>
                The concept behind the Hipobuy Spreadsheet emerged from the need for efficient product research. Shoppers who want to compare multiple items across different categories — from sneakers and hoodies to accessories and fragrances — can browse through organized columns and rows that display key information such as pricing, sizing, material details, and availability at a glance.
              </p>
              <p>
                What makes the Hipobuy Spreadsheet particularly valuable is its regular update cycle. The listings are refreshed to reflect current inventory, trending products, and new category additions. This ensures that shoppers are always working with relevant, accurate information rather than outdated catalogs.
              </p>
              <p>
                For anyone who values smart, efficient product discovery — whether they are seasoned shoppers or complete beginners — the Hipobuy Spreadsheet serves as a trusted starting point. It removes the guesswork from online browsing and replaces it with a clear, organized pathway to finding exactly what you need.
              </p>
            </div>

            {/* Stats */}
            <div className="flex gap-10 md:gap-14 mt-8 pt-6 border-t border-background-200/70">
              <div>
                <span className="block font-heading text-2xl md:text-3xl font-bold text-foreground-900">14+</span>
                <span className="text-xs md:text-sm text-foreground-500">Product Categories</span>
              </div>
              <div>
                <span className="block font-heading text-2xl md:text-3xl font-bold text-foreground-900">1K+</span>
                <span className="text-xs md:text-sm text-foreground-500">Listed Products</span>
              </div>
              <div>
                <span className="block font-heading text-2xl md:text-3xl font-bold text-foreground-900">Daily</span>
                <span className="text-xs md:text-sm text-foreground-500">Updates</span>
              </div>
            </div>
          </div>

          {/* Right - Image Card */}
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20fashion%20boutique%20interior%20with%20clothing%20racks%20and%20accessory%20displays%2C%20warm%20architectural%20lighting%2C%20premium%20retail%20space%20with%20clean%20lines%20and%20neutral%20palette%2C%20editorial%20architectural%20photography%2C%20luxury%20shopping%20environment%20with%20soft%20ambient%20glow&width=800&height=600&seq=about-hipobuy-spreadsheet-01-v2&orientation=landscape"
                alt="Hipobuy Spreadsheet organized product catalog"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm">
                <span className="text-xs font-semibold text-foreground-800">Organized Product Discovery</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent p-5">
                <p className="text-sm text-background-50">Structured listings for smarter shopping decisions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}